const tokens = {
  mainColor: "#fe6a00",
  mainColorDark: "#cc5500",
};

function applyTheme() {
  if (typeof document === "undefined") {
    return;
  }

  const root = document.documentElement;
  root.style.setProperty("--main-color", tokens.mainColor);
  root.style.setProperty("--main-color-dark", tokens.mainColorDark);
}

module.exports = { tokens, applyTheme };
